/* eslint-disable import/prefer-default-export */
import React from 'react';

export const StateInputCalendarIcon = () => (
  <label htmlFor="dateFrom" className="position-absolute top-50 end-0 translate-middle-y">
    <img src="./assets/images/date-outline.svg" alt="calendar" />
  </label>
);
